import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Mail } from "lucide-react";

const SUPPORT_EMAIL = "slike.care@timesinternet.in";

interface RedirectLoopDialogProps {
  isOpen: boolean;
  onClose: () => void;
  targetOrigin?: string | null;
}

export function RedirectLoopDialog({ isOpen, onClose, targetOrigin }: RedirectLoopDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <div className="flex items-center gap-4 mb-4">
            <div className="relative w-16 h-16 shrink-0 rounded-2xl flex items-center justify-center bg-destructive/10">
              <AlertTriangle className="w-8 h-8 text-destructive" />
            </div>
            <div className="flex-1">
              <DialogTitle className="text-2xl font-bold">Something went wrong</DialogTitle>
              <DialogDescription className="text-base mt-1">
                We detected a redirect loop while trying to sign you in.
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="rounded-lg border border-border/50 bg-muted/30 p-4">
            <div className="flex items-start gap-3">
              <div className="rounded-full bg-muted p-2 mt-0.5">
                <Mail className="w-4 h-4 text-muted-foreground" />
              </div>
              <div className="flex-1 space-y-1">
                <p className="text-sm font-medium">Need help?</p>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Please contact{" "}
                  <a
                    href={`mailto:${SUPPORT_EMAIL}`}
                    className="font-medium text-primary hover:underline"
                  >
                    {SUPPORT_EMAIL}
                  </a>{" "}
                  with details about what you were trying to access.
                </p>
              </div>
            </div>
          </div>

          {targetOrigin && (
            <div className="text-sm text-muted-foreground">
              <span className="font-medium text-foreground">Requested service:</span>{" "}
              <span className="break-all">{targetOrigin}</span>
            </div>
          )}
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button onClick={onClose} className="w-full sm:w-auto gradient-primary">
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
